import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { RestArticleCodeService } from 'src/app/service/rest/article-code/rest-article-code.service';
import { PageService } from 'src/app/service/utils/page.service';
import { TranslateFirebaseService } from 'src/app/service/utils/translate-firebase.service';
import { ArticleCode } from './article-code.model';
import { ArticleCodesRepositoryService } from './article-codes-repository.service';

@Injectable()
export class ArticleCodeService {

  private _articleCode: ArticleCode = null;
  
  constructor(private articleCodeRest: RestArticleCodeService,) { }
  
  public get articleCode(): ArticleCode {
    return this._articleCode;
  }
  public set articleCode(value: ArticleCode) {
    this._articleCode = value;
  }

  createArticleCode() : Observable<ArticleCode> {
    return this.articleCodeRest.createArticleCode(this.articleCode);
  }

  updateArticleCode() : Observable<ArticleCode> {
    return this.articleCodeRest.updateArticleCode(this.articleCode);
  }

  deleteArticleCode(articleId: number) {
    return this.articleCodeRest.deleteArticleCode(articleId);
  }

  getArticleCodeById(articleId: number) : Observable<ArticleCode>{
    return this.articleCodeRest.getArticleCodeById(articleId);

  }
}
